import React from 'react';
import { useState } from "react";
import { database } from '../../firebaseConfig'
import { collection, addDoc, deleteDoc, doc } from "firebase/firestore";
import AdminDashboard from '../../UserPanel/Shared/AdminDashboard/AdminDashboard';
import './ManageOnGoingProjects.css'

const ManageOnGoingProjects = (props) => {
    const collectionRef = collection(database, "onGoingProjects");

    const [image, setImage] = useState('');
    const [data, setData] = useState({});

    const handleInput = (event) => {
        let newInput = { [event.target.name]: event.target.value };
        setData({ ...data, ...newInput });
    };



    const handleSubmit = () => {
        if (image) {
            addDoc(collectionRef, {
                img: image,
                name: data.name,


            }).then(() => {
                document.getElementById('image').value = '';
                document.getElementById('name').value = '';
                alert('image is uploaded')
            }).catch((error) => {
                alert(error.message);
                document.getElementById('image').value = '';
                document.getElementById('name').value = '';

            })
        }
        else {
            alert("no Image Found")
        }

    }

    const handleDelete = (id) => {

        deleteDoc(doc(database, "onGoingProjects", id)).then(() => {
            alert("image deleted")
        })


    }


    const convert2base64 = e => {
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onloadend = () => {
            setImage(reader.result.toString());
        }
        reader.readAsDataURL(file);
    }

    return (
        <div className='onGoingBack'>
            <AdminDashboard></AdminDashboard>
            <div className='container  '>
                <div className="row justify-content-md-center d-flex">
                    <div className="submitBox mt-5">
                        <input
                            id="name"
                            name="name"
                            placeholder="Name"
                            onChange={(event) => handleInput(event)} /><br />

                        {/* <input
                            id="category"
                            name="category"
                            placeholder="category"
                            onChange={(event) => handleInput(event)} /> <br /> */}
                        <input id="image" type="file" style={{ "marginTop": "27px" }} onChange={e => convert2base64(e)} />
                        <button className='btn btn-success' onClick={handleSubmit}>Submit</button>
                    </div>

                    <table className='tableBox'>
                        <tr className='projectBox'>
                            <th>Image</th>
                            <th>Name</th>

                            <th>Button</th>
                        </tr>

                        {props?.onGoingProjects.map((item) => {
                            return (
                                <tr key={item.id} className='projectBox'>
                                    <td><img src={item.img} height="100px" width="100px" style={{ borderRadius: "50%" }} alt="" /></td>
                                    <td>{item.name}</td>

                                    <td>  <button className='btn btn-danger m-2' onClick={() => handleDelete(item.id)} >Delete</button></td>

                                </tr>
                            )
                        })}
                    </table>
                </div>
            </div>
        </div>

    );
}

export default ManageOnGoingProjects;

